import { useEditorStateContext } from '../../context/notes/notes_editor_state_context';
import { useState, useCallback } from 'react';
import { CANCEL_SEND_NOTE_BUTTON, CONFIRM_SEND_NOTE_BUTTON, SEND_NOTE_BUTTON, } from '../../components/notes/consts';
export function useSendNoteButton() {
    const [shouldShowModal, setShouldShowModal] = useState(false);
    const { captureButtonClick, isSendNoteDisabledYn, noteFinalizedYn, sendNoteEnabledYn } = useEditorStateContext();
    const openModal = useCallback(() => {
        typeof captureButtonClick === 'function' && captureButtonClick(SEND_NOTE_BUTTON);
        setShouldShowModal(true);
    }, [captureButtonClick]);
    const closeModal = useCallback(() => {
        typeof captureButtonClick === 'function' &&
            captureButtonClick(noteFinalizedYn ? CONFIRM_SEND_NOTE_BUTTON : CANCEL_SEND_NOTE_BUTTON);
        setShouldShowModal(false);
    }, [captureButtonClick, noteFinalizedYn]);
    return {
        closeModal,
        noteFinalizedYn,
        disabledYn: isSendNoteDisabledYn,
        openModal,
        shouldShowModal,
        sendNoteEnabledYn,
    };
}
//# sourceMappingURL=use_send_note_button.js.map